export default (codeList, code) => {
    const link = codeList.find((codeValue) => codeValue.get("code") === code);
    if (!link) {
        return "";
    }
    return link.get("link");
};
